import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import userx from "../../user.png"

import EmpNew from "./EmpNew";
import EmpEdit from "./EmpEdit";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";


import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";
import GroupList from "./GroupList";



function Emps(props)
{
    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: props.mainView.readFilter('p_imie_nazwisko',''),  
        archiwalny:  props.mainView.readFilter('archiwalny','0'), 
        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'pracownik przeniesiony do archiwum do archiwum',
            filter: {  filed: "archiwalny", set: "1", typ: "combo"  },
        },
    ]);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const tabRef = useRef(0); //do druku

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    
    const [optionTakNie, setOptionTakNie]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Nie'
        }, {
            v: '1',
            title: 'Tak'
        }
    ]
    );


    
    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
 
         props.mainView.writeFilter(filedName, val);
     }
 

     const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


 
     const goNextNew = () => {
         console.log("goNext");    
         setTab(null);    
     }


     const filterClear = () => {

 

        setFilterParam({
            p_imie_nazwisko: '', 
     
            archiwalny: '0',           
            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);


        props.mainView.writeFilter('p_imie_nazwisko','');    
        props.mainView.writeFilter('archiwalny','');
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
}


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_emps,list', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }



    const goDeleteOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_emps,remove', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pracownik został przeniesiony do archiwum" , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz przenieś pracownika do archiwum?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteOK(id);
                        //--------
        } );
    }






    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }
    
    
      if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }
    
    
 



        if(view.v == 'new')
            {
                return <EmpNew  userData={props.userData} mainView={props.mainView} onBack={onBack}   />
            }


        if(view.v == 'edit')
                {
                    var searchRow = null;
                    for(var k=0; k<tab.length; k++)
                    {
                        if(tab[k].id == view.id) { searchRow = tab[k]; break; }
                    }
            
                    return <EmpEdit  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />
                }  
                
                
      



        return (

            <div className="view_content">
 

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                   
                <div className="table_filter">
                            
                                    
                                    <div className="filter_controll">   
                                        <label>Pracownik: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.p_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="p_imie_nazwisko" placeholder={"Pracownik: "}   />
                                    </div>  

                                

                                    <div className="filter_controll">   
                                        <label>Archiwum: </label>                             
                                        <InputCombo   userData={props.userData} value={filterParam.archiwalny} items={optionTakNie}  valChange={valChangeListener} goNext={goNextNew} name="archiwalny" placeholder={"Archiwalny: "}   />
                                    </div> 


                                    <div className="filter_btn">
                                        <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                    </div>

                    </div>
                } 
    
    
    
    
    
                <div className="bg_center">
    
    
                        <div className="table_widget">
                                  <div className="btn" onClick={changeView} v="new" id="-1"  > nowy pracownik</div>
    
                                  <InputPagger filter={filterParam}  onChange={onChangePagger}  />

                                  <InputLegend items={legend} valChange={valChangeListener}/>
                               
                        </div>
     
    
                            <div className="scorll_x">
                                <table className="table" ref={tabRef}>
                                            <thead>
                                                <tr className="header">
                                                    <td className="td_left">LP</td>                                                                                    
                                                    <td>Zdjęcie</td>    
                                                    <td>Nazwisko, imię</td>                                                                                     
                                                    <td>Przypisane grupy</td>                                                                                     
                                                    <td>E-mail</td>    
                                                    <td>Telefon</td>    
                                                    <td>Umowa od/do</td>
                                                    <td>Ważność badań od/do</td>
                                                    <td>BHP od/do</td>
                                                    <td>Sanepid od/do</td>
                                                    <td className="td_right">PPP od/do</td>
                                                    <td className="td_option"> </td>
                                                                                                 
                                                </tr>
                                            </thead>
                                            <tbody>
    
                                                {
                                                    tab.map( (row, ix) => {
    
                                                        var cls = "";
                                                        if(row.archiwalny == '1') cls = "color_deleted";

                                                        var aw = <img src={"data:image/jpeg;base64," + row.awatar } />
                                                        if(row.awatar.length < 3) aw =  <img src={ userx } />

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return (
                                                            <tr className={ rowStyle  + cls}  key={ix+"r"} > 
                                                                <td className="gocenter">{ix+1}</td>                                                                                                 
                                                                <td className="gocenter img_round">  {aw} </td>    
                                                                <td onClick={changeView} v="edit" id={row.id}  className="link_normal">{row.nazwisko + " " + row.imie  }</td>                                                

                                                                <td className="gocenter"> <GroupList tab={row.grupy} />  </td>
                                                                                                             
                                                                <td onClick={changeView} v="edit" id={row.id}  className="link_normal goleft"  >{row.e_mail_kontakt}</td> 
                                                                <td onClick={changeView} v="edit" id={row.id}  className="link_normal gocenter"  >{row.telefon_kontaktowy}</td>

                                                                <td className="gocenter">
                                                                    {
                                                                        (row.umowa_pracownika_od.length > 1 || row.umowa_pracownika_do.length > 1 ) &&
                                                                        <Fragment>
                                                                            {row.umowa_pracownika_od + " / "+row.umowa_pracownika_do}
                                                                        </Fragment>
                                                                    }                                                                   
                                                                </td>

                                                                <td className="gocenter">
                                                                    {
                                                                        (row.waznosc_badan_prac_od.length >0 || row.waznosc_badan_prac_do.length > 0 ) &&
                                                                        <Fragment>
                                                                            {row.waznosc_badan_prac_od + " / "+row.waznosc_badan_prac_do}
                                                                        </Fragment>
                                                                    }                                                                    
                                                                </td>

                                                                <td className="gocenter">
                                                                    {
                                                                        (row.waznosc_badan_bhp_od.length > 0 || row.waznosc_badan_bhp_do.length > 0 ) &&
                                                                        <Fragment>
                                                                            {row.waznosc_badan_bhp_od + " / "+row.waznosc_badan_bhp_do}
                                                                        </Fragment>
                                                                    }                                                                    
                                                                </td>

                                                                <td className="gocenter">
                                                                    {
                                                                        ( row.sanepid_od.length >0 || row.sanepid_do.length > 0 ) &&
                                                                        <Fragment>
                                                                            {row.sanepid_od + " / "+row.sanepid_do}
                                                                        </Fragment>
                                                                    }                                                                    
                                                                </td>

                                                                <td className="gocenter">
                                                                    {
                                                                        (row.ppp_od.length >0 || row.ppp_do.length >0 ) &&
                                                                        <Fragment>
                                                                            {row.ppp_od + " / "+row.ppp_do} 
                                                                        </Fragment>
                                                                    }                                                                                                                                     
                                                                </td>
                                                               
                                    
                                                                <MenuTable>
                                                                    <ul>
                                                                        <li  onClick={changeView} v="edit" id={row.id} >zmień dane</li>
                                                                        <li onClick={goDelete} v="delete" id={row.id} >usuń</li>
                                                                    </ul>
                                                                </MenuTable>    

                                                            </tr>  
                                                        )
                                                    } )
                                                }
    
                                            </tbody>
                                    </table>
                            </div>
                </div>
    
    
            </div>
    
        )


}


export default Emps;